import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FilterInput, FilterType } from "src/app/models/filter-input";

@Component({
    selector: "app-filter-controls",
    templateUrl: "./filter-controls.component.html",
    styleUrls: ["./filter-controls.component.scss"],
})
export class FilterControlsComponent implements OnInit {
    @Input() filterInput: FilterInput;
    @Input() filterForm: FormGroup;
    @Input() paginationParams: any;

    constructor() {}

    ngOnInit(): void {}
}
